/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from "vue";
window.Vue = Vue;

import { BootstrapVue } from "bootstrap-vue";
import VueRouter from "vue-router";
import store from "./store";

Vue.prototype.$isDev = process.env.MIX_APP_ENV !== "production";
Vue.config.devtools = Vue.prototype.$isDev;
Vue.config.debug = Vue.prototype.$isDev;
Vue.config.silent = !Vue.prototype.$isDev;

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.component(
    "dynamic-component",
    require("./components/dynamic-component").default
);

import Toasted from "vue-toasted";
Vue.use(Toasted, {
    position: "top-right",
    duration: 3000,
});
import utils from './utils'
Vue.mixin(utils)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import "./views";
import Layouts from "./mixins/layouts.mixin";

const app = new Vue({
    el: "#app",
    mixins: [Layouts],
    store,
});
